import { Appearance, RANGES } from "react-native-readium";
import { ReaderPreferences } from "../../models";
import { ReaderTheme } from "../../enums";
export const readerSettingsToPreferences = (previousState) => {
    const readerSettings = previousState._readerSettings;
    const readerPreferences = new ReaderPreferences();
    switch (readerSettings?.appearance) {
        case Appearance.DEFAULT:
            readerPreferences.theme = ReaderTheme.LIGHT;
            break;
        case Appearance.NIGHT:
            readerPreferences.theme = ReaderTheme.DARK;
            break;
        case Appearance.SEPIA:
            readerPreferences.theme = ReaderTheme.SEPIA;
            break;
        default:
            readerPreferences.theme = undefined;
            break;
    }
    if (readerSettings?.fontSize ||
        (readerSettings.fontSize / 100) > RANGES.fontSize[1]) {
        readerPreferences.fontSize = readerSettings.fontSize / 100;
    }
    else {
        readerPreferences.fontSize = RANGES.fontSize[0];
    }
    const newState = { ...previousState, _readerPreferences: readerPreferences };
    delete newState._readerSettings;
    delete newState.getReaderSettings;
    delete newState.setReaderSettings;
    return newState;
};
//# sourceMappingURL=readerSettingsToPreferences.js.map